<template>
  <div class="homeAll" ref="content">
    <div class="content-contain swiperCarrousel" ref="contentContain">
      <!-- topBanner -->
      <div class="row swiper-container pad-top-5 topBanner" ref="containHappy" style="height: 583px; position: relative" >
        <swiper
          class="swiper-container-home"
          :options="swiperOption"
          ref="myswiper"
          v-bind:style="{ height: swiperHeight + 'px' }"
          v-if="topBannerVoList && topBannerVoList.length"
        >
          <swiper-slide
            v-for="(topBanner, index) in topBannerVoList"
            :key="index"
            class="content-contain-happy col-xs-12 col-sm-12 col-md-12 pad-0"
            style="width: 100%"
          >
            <!-- <div class="warp-mask" @click="goDetail($store.getters.getObject(topBanner.langMap).url)"></div> -->
            <!-- <a class="displayA" :href="goDetail($store.getters.getObject(topBanner.langMap).url)"></a> -->
            <div class="topBanner-contain row content-1320px">
              <div class="warp-mask" @click="goDetail($store.getters.getObject(topBanner.langMap).url)"></div>

              <div class="topBanner-content ani" swiper-animate-effect="fadeInUp">
                <div class="topBanner-title Bold oran">
                  {{ $store.getters.getObject(topBanner.langMap).title }}
                </div>
                <div class="topBanner-name mainColor">
                  <a href="javascript:;" style="color: inherit">{{ $store.getters.getObject(topBanner.langMap).name }}</a>
                </div>
                <div class="topBanner-sd">
                  {{
                    $store.getters.getObject(topBanner.langMap).shortDescription
                  }}
                </div>
              </div>

              <div class="topBanner-img">
                <div class="topBannerImg" :ref="`topBannerImg${index}`">
                  <img v-if="$store.getters.getObject(topBanner.langMap).bannerImage" :alt="$store.getters.getObject(topBanner.langMap).name" :src="$store.getters.getObject(topBanner.langMap).bannerImage"/>
                  <img v-if="!$store.getters.getObject(topBanner.langMap).bannerImage" :alt="$store.getters.getObject(topBanner.langMap).name" class="default-mobile" src="../images/banner.png" />
                </div>

                <div class="default1">
                  <img src="../images/default1.png"/>
                </div>
                <div class="default2">
                  <img src="../images/default2.png"/>
                </div>
                <div class="default3">
                  <img src="../images/default3.png"/>
                </div>
                <div class="bannerBG1">
                  <img src="../images/bannerBG1.png" />
                </div>
                <div class="bannerBG2">
                  <img src="../images/bannerBG2.png" />
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>

        <div class="swiper-topBanner-prev swiper-arrowBtn-left swiper-arrowBtn swiper-topBanner-btn" slot="button-prev" ref="btnPrev" v-if="topBannerVoList.length > 1">
          <i class="icon-arrow-down swiper-button-leftJia"></i>
        </div>
        <div class="swiper-topBanner-next swiper-arrowBtn-right swiper-arrowBtn swiper-topBanner-btn" slot="button-next" ref="btnNext" v-if="topBannerVoList.length > 1">
          <i class="icon-arrow-down swiper-button-rigthJia"></i>
        </div>
      </div>
      
      <!-- hotOccupations -->      
      <div class="row hotOccupations">
        <div class="hotOccupations-content" id="hotOccupations">
          <div
            class="row content-1320px hotOccupationsPC occupationDetails"
            :class="{ occupationDetailsPC: $store.state.innerWidth > 768 }"
            style="overflow: hidden"
          >
            <div class="hotOccupations-title">
              <h2 class="title-text">
                {{ $t("message.Hot Occupations") }}
                <div class="ho-VSO">
                  <img class="noSelect" src="../images/Vector Smart Object1.png" alt />
                </div>
              </h2>
            </div>
            <SwiperOccupation ref="SwiperOccupation" :occupation-list="occupations"></SwiperOccupation>
            <div class="hotOccupations-btn col-xs-12 col-sm-12 col-md-12">
              <div class="btn-primary btn-250 SemiBold font-size-14" @click="navTo('browseOccupations')" role="button" :aria-label="$t('message.View all Occupation')">
                <a href="javascript:;" style="color: inherit">{{ $t("message.View all Occupation") }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- hotJob -->
    <div class="row featuredJob" ref="jobSear">
      <!-- <FindOpportunityHome
        v-bind:needOptions="false"
        :search="searchEvent"
      ></FindOpportunityHome> -->
      <div class="featuredJob-placeImg">
        <div class="fj-deco-13">
          <img class="noSelect" src="../images/deco-13.png" alt />
        </div>
        <div class="fj-deco-11">
          <img class="noSelect" src="../images/deco-11.png" alt />
        </div>
      </div>
      <div class="featuredJob-content" id="Featured Job">
        <div
          class="row content-1320px featuredJobPC occupationDetails"
          :class="{ occupationDetailsPC: $store.state.innerWidth > 768 }"
          style="overflow: hidden"
        >
          <div class="featuredJob-title">
            <h2 class="title-text">
              {{ $t("message.Featured Jobs") }}
              <div class="fj-BG-deco">
                <img class="noSelect" src="../images/O green1 copy.png" alt />
              </div>
            </h2>

            <div class="featuredJob-search-btn">
              <div
                class="greenBtn btnExpand SemiBold font-size-14"
                :class="{ 'btn-active': this.btnActive == 'privateJob' }"
                @click="showHomeJobList('privateJob')"
                role="button" 
                :aria-label='$t("message.Private Sector")'
              >
                <a href="javascript:;" style="color: inherit;">{{ $t("message.Private Sector") }}</a>
              </div>
              <div
                class="greenBtn btnExpand SemiBold font-size-14"
                :class="{ 'btn-active': this.btnActive == 'governmentJob' }"
                @click="showHomeJobList('governmentJob')"
                role="button" 
                :aria-label='$t("message.Government Sector")'
              >
                <a href="javascript:;" style="color: inherit;">{{ $t("message.Government Sector") }}</a>
              </div>
            </div>
          </div>
          <SwiperJob ref="SwiperJob" :job-list="jobFunctions[btnActive]" page="HomePage"></SwiperJob>
          <div class="featuredJob-btn col-xs-12 col-sm-12 col-md-12">
            <div class="btn-primary btn-250 SemiBold font-size-14" @click="navTo('findAnOpportunity')" role="button" :aria-label='$t("message.View all Featured Jobs")'>
              <a href="javascript:;" style="color: inherit;">{{ $t("message.View all Featured Jobs") }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- hotCourses -->
    <div class="row hotCourses" ref="hotCourses">
      <div class="hotCourses-placeImg">
        <div class="hc-deco-19">
          <img class="noSelect" src="../images/deco-19.png" alt />
        </div>
      </div>
      <div class="hotCourses-content" id="Hot Courses">
        <div
          class="row content-1320px hotCoursesPC occupationDetails"
          :class="{ occupationDetailsPC: $store.state.innerWidth > 768 }"
          style="overflow: hidden"
        >
          <div class="hotCourses-title">
            <h2 class="title-text">
              {{ $t("message.Popular Courses") }}
              <div class="hc-deco-22">
                <img class="noSelect" src="../images/deco-22.png" alt />
              </div>
            </h2>

            <div class="hotCourses-search-btn">
              <div
                class="greenBtn btnExpand SemiBold font-size-14"
                :class="{ 'btn-active': this.courseType == 'qrCourse' }"
                @click="clickCourses('qrCourse')"
                role="button"
                aria-label='$t("message.QR Courses")'
              >
                <a href="javascript:;" style="color: inherit;">{{ $t("message.QR Courses") }}</a>
              </div>
              <div
                class="greenBtn btnExpand SemiBold font-size-14"
                :class="{ 'btn-active': this.courseType == 'edxCourse' }"
                @click="clickCourses('edxCourse')"
                role="button"
                aria-label='$t("message.MOOC Courses")'
              >
                <a href="javascript:;" style="color: inherit;">{{ $t("message.MOOC Courses") }}</a>
              </div>
            </div>
          </div>
          <SwiperQRcourses
            :course-list="courses.qrCourse"
            v-if="courseType == 'qrCourse' && courses.qrCourse.length > 0"
          ></SwiperQRcourses>
          <SwiperMOOCcourses
            :course-list="courses.edxCourse"
            v-if="courseType == 'edxCourse' && courses.edxCourse.length > 0"
          ></SwiperMOOCcourses>
          <div class="hotCourses-btn col-xs-12 col-sm-12 col-md-12">
            <div class="btn-primary btn-250 SemiBold font-size-14" @click="navTo('browseCourses')" role="button" :aria-label='$t("message.View all Popular Courses")'>
              <a href="javascript:;" style="color: inherit;">{{ $t("message.View all Popular Courses") }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Dicover -->
    <div class="row discover" ref="discover">
      <div class="discover-contain">
        <div class="row content-1320px discoverPC">
          <div class="discover-title mainColor">
            <h2 class="title-text">
              {{ $t("message.Discover") }}
              <div class="dis-deco-10">
                <img class="noSelect" src="../images/deco-10.png" alt />
              </div>
            </h2>

            <div class="discover-description">
              <p>{{ $t("message.Discover Description") }}</p>
            </div>
          </div>

          <div class="discover-content">
            <div class="discover-item">
              <div class="discoverItem-img">
                <img src="../images/discover/discover1.png" :alt="$t('message.browseOccupations')"/>
                <div ref="slideOutRight1" class="curtain"></div>
              </div>

              <div class="discoverItem-contain">
                <div ref="slideInUp1" class="discoverItem-title mainColor">
                  <!-- <span>{{$t("message.browseOccupations")}}</span> -->
                  <!-- <span class="slideInUp" :style="`animation-delay: ${50*index}ms;`" v-for="(item, index) in $t('message.browseOccupations')" :key="index">{{item}}</span>  -->
                  <span :ref="'slideInUp1'+index" :style="`animation-delay: ${25*index}ms;`" v-for="(item, index) in $t('message.browseOccupations')" :key="index">{{item}}</span> 
                </div>
                <div ref="slideInLeft1" class="discoverItem-content">
                  <p>{{$t("message.browseOccupations_text")}}</p>
                </div>
                <div class="discoverItem-btn">
                  <div class="btn-primary btn-250 SemiBold font-size-14" @click="navTo('browseOccupations')" role="button" :aria-label='$t("message.View all occupations")'>
                    <a href="javascript:;" style="color: inherit;">{{ $t("message.View all occupations") }}</a>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="discover-item">
              <div class="discoverItem-img">
                <img src="../images/discover/discover2.png" :alt="$t('message.findJob')"/>
                <div ref="slideOutRight2" class="curtain"></div>
              </div>

              <div class="discoverItem-contain">
                <div ref="slideInUp2" class="discoverItem-title mainColor">
                  <!-- {{$t("message.findJob")}} -->
                  <!-- <span class="slideInUp" :style="`animation-delay: ${50*index}ms;`" v-for="(item, index) in $t('message.findJob')" :key="index">{{item}}</span>  -->
                  <span :ref="'slideInUp2'+index" :style="`animation-delay: ${25*index}ms;`" v-for="(item, index) in $t('message.findJob')" :key="index">{{item}}</span> 
                </div>
                <div ref="slideInLeft2" class="discoverItem-content">
                  <p>{{$t("message.findJob_text")}}</p>
                </div>
                <div class="discoverItem-btn">
                  <div class="btn-primary btn-250 SemiBold font-size-14" @click="navTo('findAnOpportunity')" role="button" :aria-label='$t("message.View all findJob")'>
                    <a href="javascript:;" style="color: inherit;">{{ $t("message.View all findJob") }}</a>
                  </div>
                </div>
              </div>
            </div>

            <div class="discover-item">
              <div class="discoverItem-img">
                <img src="../images/discover/discover3.png" :alt="$t('message.browseCouses')" />
                <div ref="slideOutRight3" class="curtain"></div>
              </div>

              <div class="discoverItem-contain">
                <div ref="slideInUp3" class="discoverItem-title mainColor">
                  <!-- {{$t("message.browseCouses")}} -->
                  <!-- <span class="slideInUp" :style="`animation-delay: ${50*index}ms;`" v-for="(item, index) in $t('message.browseCouses')" :key="index">{{item}}</span> -->
                  <span :ref="'slideInUp3'+index" :style="`animation-delay: ${25*index}ms;`" v-for="(item, index) in $t('message.browseCouses')" :key="index">{{item}}</span>
                </div>
                <div ref="slideInLeft3" class="discoverItem-content">
                  <p>{{$t("message.browseCouses_text")}}</p>
                </div>
                <div class="discoverItem-btn">
                  <div class="btn-primary btn-250 SemiBold font-size-14" @click="navTo('browseCourses')" role="button" :aria-label='$t("message.View all browseCouses")'>
                    <a href="javascript:;" style="color: inherit;">{{ $t("message.View all browseCouses") }}</a>
                  </div>
                </div>
              </div>
            </div>

            <div class="discover-item">
              <div class="discoverItem-img">
                <img src="../images/discover/discover4.png" :alt="$t('message.careerQuizzes')" />
                <div ref="slideOutRight4" class="curtain"></div>
              </div>

              <div class="discoverItem-contain">
                <div ref="slideInUp4" class="discoverItem-title mainColor">
                  <!-- {{$t("message.careerQuizzes")}} -->
                  <!-- <span class="slideInUp" :style="`animation-delay: ${50*index}ms;`" v-for="(item, index) in $t('message.careerQuizzes')" :key="index">{{item}}</span> -->
                  <span :ref="'slideInUp4'+index" :style="`animation-delay: ${25*index}ms;`" v-for="(item, index) in $t('message.careerQuizzes')" :key="index">{{item}}</span>
                </div>
                <div ref="slideInLeft4" class="discoverItem-content">
                  <p>{{$t("message.careerQuizzes_text")}}</p>
                </div>
                <div class="discoverItem-btn">
                  <div class="btn-primary btn-250 SemiBold font-size-14" @click="navTo('selfAssessment')" role="button" :aria-label='$t("message.View all careerQuizzes")'>
                    <a href="javascript:;" style="color: inherit;">{{ $t("message.View all careerQuizzes") }}</a>
                  </div>
                </div>
              </div>
            </div>

            <div class="placeImg">
              <div class="dc-deco-19">
                <img  src="../images/deco-19.png"/>
              </div>
              <div class="dc-deco-23">
                <img  src="../images/deco-23.png"/>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Career Magazine -->
    <div class="row careerMagazine">
      <div class="hot-picks Bold" ref="hotPicks">
        <div class="hot-picks-title titleImg col-xs-12 col-sm-12 col-md-12">
          <h2 class="hot-picks-titleText titleText">
            {{ $t("message.Career Magazine") }}
            <div class="hot-picks-titlePlaceImg">
              <img class="hot-picks-titleImg noSelect" src="../images/Vector Smart Object20.png" draggable="false" alt />
            </div>
            <div class="hot-picks-logo">
              <img src="../images/logo-05.png" draggable="false" alt />
            </div>
          </h2>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 content-1320px hot-picks-contain pad-0">
          <div
            class="col-xs-12 col-sm-12 col-md-4 hot-picks-ad hot-picks-adHome"
            v-for="(article, index) in articles"
            v-if="articles && articles.length && index < 3"
            @click="goMagazineDetail(article)"
            :key="index" >
            <div class="col-xs-6 col-sm-6 col-md-12 hot-picks-placeImg pad-0">
              <img
                class="hot-picks-img noSelect"
                draggable="false"
                :src="$store.getters.getObject(article.langMap).coverPhoto"
                :alt="$store.getters.getObject(article.langMap).title"
              />
              <div class="positive"></div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-12 hot-picks-right">
              <div class="hot-picks-subtitle hot-picks-subtitleHome SemiBold">
                {{ $store.getters.getContent(article.subCategoryList[0].langMap) }}
              </div>
              <p></p>
              <div class="hot-picks-information hot-picks-informationHome">
                <span class="hover-line hover-lineHome Bold three-box">
                  <a href="javascript:;" style="color: inherit">{{ $store.getters.getObject(article.langMap).title }}</a>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12">
          <div class="btn-primary hot-picks-btn btn-250 SemiBold font-size-14" @click="pushOnlineMagazine()" role="button" :aria-label='$t("message.All articles")'>
            <a href="javascript:;" style="color: inherit">{{ $t("message.All articles") }}</a>
          </div>
        </div>
      </div>
    </div>

    <!-- department banner -->
    <div class="row department-banner">
      <div class="row department-banner-content">
        <div class="row content-1320px">
          <SwiperDepartment
            :departmentBannerVoList="departmentBannerVoList"
            ref="SwiperDepartment"
          ></SwiperDepartment>
        </div>
        <div class="db-deco-12">
          <img
            class="noSelect"
            src="../images/deco-12.png"
            draggable="false"
            alt
          />
        </div>
      </div>
    </div>

    <!-- floating banner -->
    <div class="row floating-banner" :class="{ bannerClose: this.isClose }" ref="floatingBanner">
      <div class="row floating-banner-content content-1320px">
        <SwiperBanner
          :floatingBannerVoList="floatingBannerVoList"
        ></SwiperBanner>
      </div>
    </div>
    
  </div>
</template>
<script>
import FindOpportunity from "@/components/FindOpportunity";
import FindOpportunityHome from "@/components/FindOpportunityHome";
import SwiperBanner from "@/components/SwiperBanner";
import SwiperJob from "@/components/SwiperJob";
import SwiperDepartment from "@/components/SwiperDepartment";
import SwiperQRcourses from "@/components/SwiperQRcourses.vue";
import SwiperMOOCcourses from "@/components/SwiperMOOCcourses.vue";
import SwiperOccupation from "@/components/SwiperOccupation.vue";
import AOS from "aos";
import "aos/dist/aos.css";
import { EventBus } from "@/javascripts/eventBus.js";

export default {
  name: "home",
  data() {
    let that = this;
    return {
      fullWidth: document.documentElement.clientWidth,
      shu: "",
      leardDistance: "",
      orientationDistance: "",
      learnEnter: true,
      orientationEnter: true,
      lineImg: "",
      banners: [],
      articles: [],
      occupations: [],
      swiperHeight: 583,
      swiperOption: {
        //swiper3
        slidesPerView: 1,
        spaceBetween: 200,
        loop: false,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        navigation: {
          nextEl: ".swiper-topBanner-next",
          prevEl: ".swiper-topBanner-prev",
        },
        on: {
          init: function() {
            that.$swiperAnimateCache(this);
            that.$swiperAnimate(this);
          },
          slideChange: function() {
            that.$swiperAnimate(this);
          }
        }
      },
      isClose: false,
      jobFunctions: {},
      totalRows: 0,
      btnActive: "privateJob",
      departmentBannerVoList: [],
      floatingBannerVoList: [],
      topBannerVoList: [],
      courses: {
        qrCourse: [],
        edxCourse: [],
      },
      courseType: "qrCourse",
      showSwiper: false,
      scrollT: 0,
    };
  },
  props: ["logGaEvent"],
  components: {
    FindOpportunity,
    FindOpportunityHome,
    SwiperBanner,
    SwiperJob,
    SwiperDepartment,
    SwiperQRcourses,
    SwiperMOOCcourses,
    SwiperOccupation,
  },
  methods: {
    pushOnlineMagazine() {
      if (this.$store.state.isPreview) return;
      this.logGaEvent("userClick", "goOnlineMagazine", "goOnlineMagazine");
      this.$router.push({
        path: "/magazine",
        query: { lang: this.$store.state.language },
      });
      window.scrollTo(0, 0);
      this.$store.state.formData.headTabState1 = true;
    },
    pushSelfAssessment: function () {
      if (this.$store.state.isPreview) return;
      this.logGaEvent("userClick", "goSelfAssessment", "goSelfAssessment");
      this.$router.push({
        path: "/selfAssessment",
        query: { lang: this.$store.state.language },
      });
    },
    //改变盒子宽
    browSize: function () {
      this.$refs.brow.style.height = this.$refs.brow.offsetWidth + "px";
      var browIn = document.getElementsByClassName("browse-item-information");
      this.fullWidth = document.documentElement.clientWidth;
      browIn = Array.prototype.slice.call(browIn);
      browIn.forEach((item) => {
        item.style.lineHeight = this.$refs.brow.offsetWidth + "px";
      });
    },
    //滚动距离动画
    downLeard: function () {
      this.comment.disAnimation(this);
      if (this.shu >= this.leardDistance) {
        setTimeout(() => {
          this.learnEnter = false;
        }, 1100);
      }
    },
    downOrientation: function () {
      this.comment.disAnimation(this);
      if (this.shu >= this.orientationDistance) {
        setTimeout(() => {
          this.orientationEnter = false;
        }, 1100);
      }
    },
    distance: function () {
      this.leardDistance =
        this.swiperHeight +
        this.$refs.hotPicks.offsetHeight +
        this.$refs.browse.offsetHeight +
        this.$refs.jobSear.offsetHeight +
        0;
      this.orientationDistance =
        this.swiperHeight +
        this.$refs.hotPicks.offsetHeight +
        this.$refs.browse.offsetHeight +
        this.$refs.jobSear.offsetHeight +
        this.$refs.learnHeight.offsetHeight;
    },
    searchEvent: function (obj) {
      if (this.$store.state.isPreview) return;
      let params = {};
      if (obj.keyword) {
        params.keyword = obj.keyword;
      }
      if (obj.jobFunctionIds) {
        params.jobFunctionIds = obj.jobFunctionIds;
      }
      params.lang = this.$store.state.language;
      this.logGaEvent("userClick", "findAnOpportunity", "searchEvent");
      this.$store.state.formData.headTabState3 = true;
      window.scrollTo(0, 0);
      this.$router.push({ path: "/findAnOpportunity", query: params });

      // params
    },
    scrollToTop: function () {
      document.getElementById("optionbar").scrollIntoView();
    },
    initSwiper: function () {
      // var mySwiper = new Swiper(".swiperCarrousel .swiper-container", {});
    },
    getHomePage: function () {
      let that = this;
      this.api.getHomePage({}, function (data) {
        if (!data.result) {
          data.result = {};
        }
        that.banners = data.result.articleBannerList;
        that.articles = data.result.articleList;
        that.departmentBannerVoList = data.result.departmentBannerVoList;
        that.floatingBannerVoList = data.result.floatingBannerVoList;
        that.topBannerVoList = data.result.topBannerVoList;
        // if(that.topBannerVoList.length > 1) {
        //   that.swiperOption.loop = true;
        // }
        //
        setTimeout(function () {
          that.setBannerHeight();
        });

        that.initSwiper();
      });
    },
    getHomePageDraft: function () {
      let that = this;
      this.api.getHomePageDraft({}, function (data) {
        if (!data.result) {
          data.result = {};
        }
        that.banners = data.result.articleBannerList;
        that.articles = data.result.articleList;
        that.departmentBannerVoList = data.result.departmentBannerVoList;
        that.floatingBannerVoList = data.result.floatingBannerVoList;
        that.topBannerVoList = data.result.topBannerVoList;
        //
        // that.courses=data.result.result;
        setTimeout(function () {
          that.setBannerHeight();
        });

        that.initSwiper();
      });
    },
    navTo: function (path) {
      if (this.$store.state.isPreview) return;

      if(path == "findAnOpportunity") {
        EventBus.$emit("hotJobList",[]);
      }
      // this.closeMenu();
      this.$router.push({
        path: "/" + path,
        query: { lang: this.$store.state.language },
      });
      window.scrollTo(0, 0);
      // body...
    },
    getOccupationList: function () {
      let that = this;
      this.api.getHomeOccupationList({}, function (data) {
        that.occupations = data.result;
        //
      });
    },
    goToDetail: function (id) {
      if (this.$store.state.isPreview) return;
      this.logGaEvent("userClick", "home-occupationDetails", id);
      this.$router.push({
        path: "/occupationDetails/" + id,
        query: { lang: this.$store.state.language },
      });
    },
    goDetail: function (url) {
      if (this.$store.state.isPreview) return;
      let https = "https://";
      let http = "http://";
      if (url.indexOf(https) < 0 && url.indexOf(http) < 0) {
        url = "https://" + url;
      }
      window.open(url, "_blank");
      // this.logGaEvent("userClick", "home-onlineMagazineDetail", item.id);
      // this.$router.push({
      //   path: "/onlineMagazineDetail/" + item.id,
      //   query: { lang: this.$store.state.language },
      // });
    },
    setBannerHeight: function () {
      if (this.$store.state.innerWidth > 1300) {
        this.$refs.containHappy.style.height = "530px";
        if(this.topBannerVoList.length > 1) {
          this.$refs.btnPrev.style.top = "50%";
          this.$refs.btnNext.style.top = "50%";
        }
      } else {
        this.$refs.containHappy.style.height = "auto";
        if(this.topBannerVoList.length > 1) {
          this.$nextTick(() => {
            let rate = this.$store.state.innerWidth / 1320;
            let top = Math.round(690 * rate) / 2 + "px";
            this.$refs.btnPrev.style.top = top;
            this.$refs.btnNext.style.top = top;
          });
        }
      }
    },
    showHomeJobList: function (name) {
      this.btnActive = name;
    },
    getHomeJobList: function () {
      var that = this;
      let data = {
        startRow: 0,
        maxRows: 5,
      };
      that.api.getHomeJobList(data, function (data) {
        that.jobFunctions = data.result;
      });
    },
    clickCourses: function (courseName) {
      this.courseType = courseName;
    },
    goMagazineDetail: function(item) {
      if(this.$store.state.isPreview) return;
      this.logGaEvent('userClick','home-onlineMagazineDetail',item.id)
      this.$router.push({
          path:"/onlineMagazineDetail/" + item.id, 
          query:{
          lang:this.$store.state.language,
          name:this.$store.getters.replaceEvent(this.$store.getters.getObject(item.langMap).title)
          }
      });
    },
    getCourse: function () {
      var that = this;
      let data = { startRow: 1, maxRows: 5 };
      this.api.getCourseListInHomepage(data, function (data) {
        that.courses = data.result;
        for (let i = 0; i < that.courses.qrCourse.length; i++) {
          if (that.courses.qrCourse[i].learningMode) {
            that.courses.qrCourse[i].learningMode = that.courses.qrCourse[
              i
            ].learningMode.split(",");
          }
        }
        for (let i = 0; i < that.courses.edxCourse.length; i++) {
          if (that.courses.edxCourse[i].learningMode) {
            that.courses.edxCourse[i].learningMode = that.courses.edxCourse[
              i
            ].learningMode.split(",");
          }
        }
      });
    },
    handleScroll: function() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      this.scrollT = scrollTop;

      if(this.$refs.slideOutRight1) {      
        if (this.$refs.slideOutRight1.getBoundingClientRect().y < window.innerHeight) {
          this.$refs.slideOutRight1.classList.add('slideOutRight');
          this.$refs.slideInLeft1.classList.add('slideInLeft');
          for(let i=0; i<this.$refs.slideInUp1.innerHTML.split("</span>").length-1; i++) {
            this.$refs["slideInUp1"+i][0].classList.add('slideInUp')
          }
        }
      }

      if(this.$refs.slideOutRight2) {
        if (this.$refs.slideOutRight2.getBoundingClientRect().y < window.innerHeight) {
          this.$refs.slideOutRight2.classList.add('slideOutRight');
          this.$refs.slideInLeft2.classList.add('slideInLeft');
          for(let i=0; i<this.$refs.slideInUp2.innerHTML.split("</span>").length-1; i++) {
            this.$refs["slideInUp2"+i][0].classList.add('slideInUp')
          }
        }
      }

      if(this.$refs.slideOutRight3) {
        if (this.$refs.slideOutRight3.getBoundingClientRect().y < window.innerHeight) {
          this.$refs.slideOutRight3.classList.add('slideOutRight');
          this.$refs.slideInLeft3.classList.add('slideInLeft');
          for(let i=0; i<this.$refs.slideInUp3.innerHTML.split("</span>").length-1; i++) {
            this.$refs["slideInUp3"+i][0].classList.add('slideInUp')
          }
        }
      }

      if(this.$refs.slideOutRight4) {
        if (this.$refs.slideOutRight4.getBoundingClientRect().y < window.innerHeight) {
          this.$refs.slideOutRight4.classList.add('slideOutRight');
          this.$refs.slideInLeft4.classList.add('slideInLeft');
          for(let i=0; i<this.$refs.slideInUp4.innerHTML.split("</span>").length-1; i++) {
            this.$refs["slideInUp4"+i][0].classList.add('slideInUp')
          }
        }
      }

    }
  },
  beforeRouteLeave(to, from, next) {
    this.fromLouterName = to.name;
    this.$store.state.scrollT = this.scrollT;
    if (to.name == "onlineMagazineDetail") {
      to.meta.isUseCache = false;
    } else {
      // to.meta.isUseCache = true;
    }
    next();
  },
  mounted() {
    var that = this;
    setTimeout(function(){
      that.$store.state.mate.title = that.$i18n.t("message."+that.$route.meta.title)+' - talent.gov.hk - '+that.$i18n.t("message.Default Page Title");
    })

    if (!this.$route.query.lang) {
      this.$router.push({ query: { lang: this.$store.state.language } });
    }
    // this.api.getJobFunctionList({},function(data){
    // },function(error){
    //  // body...
    // })
    // this.lineImg = require('@/images/');
    if (this.$route.params.preview == "preview") {
      this.$store.state.isPreview = true;
    }
    this.$store.state.selectMenu = 0;
    var height = window.innerHeight - 85;
    this.$set(this, "swiperHeight", height);
    // this.$refs.learnHeight.style.height = window.innerHeight + "px";
    // this.$refs.jobSear.style.height = window.innerHeight + "px";
    // this.$refs.orientationHeight.style.height = window.innerHeight + "px";

    // this.distance();
    // window.onresize = this.browSize;
    // window.addEventListener("scroll", this.downLeard);
    var _this = this;
    AOS.init();
    // You can also pass an optional settings object
    // below listed default settings
    AOS.init({
      // Global settings:
      disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
      startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
      initClassName: "aos-init", // class applied after initialization
      animatedClassName: "aos-animate", // class applied on animation
      useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
      disableMutationObserver: false, // disables automatic mutations' detections (advanced)
      debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
      throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      offset: 120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 400, // values from 0 to 3000, with step 50ms
      easing: "ease", // default easing for AOS animations
      once: true, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    if (this.$store.state.isPreview) {
      this.getHomePageDraft();
    } else {
      this.getHomePage();
    }
    this.getOccupationList();
    EventBus.$on("closeBanner", () => {
      this.isClose = true;
    }),
    this.getHomeJobList();
    this.getCourse();
    window.addEventListener('scroll', this.handleScroll);
    if(this.$store.state.scrollT != 0) {
      setTimeout(() => {
        window.scrollTo(0, this.$store.state.scrollT)
      }, 800)
    }
  },
  computed: {
    innerHeight() {
      return this.$store.state.innerHeight;
    },
    innerwidth() {
      return this.$store.state.innerWidth;
    },
    _language(){
      return this.$store.state.language
    },
  },
  watch: {
    fullWidth(news, old) {
      this.browSize();
    },
    innerHeight(news, old) {
      this.setBannerHeight();
    },
    innerwidth(news, old) {
      this.setBannerHeight();
    },
    _language(news, old) {
    }
  },
};
</script>